module.exports = __webpack_public_path__ + "media/newstyle/images/icon-open-chart-d0e4803dd74f908a78744d6490a42509.svg";